import React from 'react';
import { Navigate } from 'react-router-dom';
import SubHeader from '../../components/Layout/SubHeader';
import { getAuthToken, storeUserData } from '../../components/Util';
import { toast } from 'react-toastify';
import api from '../../config/api';
import axios from 'axios';
import strings from '../../components/Language';
import { ProgressBar } from 'react-loader-spinner';
import { Button } from 'antd';

class MobileUpdateScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ProgressBar: false,
            isLoading: false,
            otpLoading: false,
            lang: strings.getLanguage(),
            isAuthenticated: false,
            access_token: null,
            mobile: null,
            otp_code: null,
            isOTP_code: null,
            errorMessage: [],
        }
    }

    async componentDidMount() {
        let self = this;
        var token = await getAuthToken();

        if (token) {
            self.setState({ access_token: token });
            await storeUserData(token, this);
        }
    }

    RequestOTP() {
        const self = this;
        self.setState({ otpLoading: true })

        if (!this.state.mobile) {
            toast.error(strings["mobileNumPlaceholder"]);
            return false;
        }

        axios({
            method: 'POST',
            url: api.MobileUpdateRequestOTP,
            data: {
                mobile: self.state.mobile,
                lang: self.state.lang
            },
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            self.setState({ otpLoading: false })
            if (response.data.error == 202 || response.data.error == '202') {
                if (response.data.errors && response.data.errors.length != 0) {
                    self.setState({ errorMessage: response.data.errors });
                } else {
                    var err_result = response.data.message.split("\r\n");
                    err_result.forEach(data => {
                        if (data) {
                            toast.error(data);
                        }
                    });
                }
            } else {
                toast.success(response.data.message);
                self.setState({ isOTP_code: response.data.otp_code });
            }

        }).catch(function (error) {
            toast.error(strings["no_internet"]);
        });
    }

    onPressProfile() {
        const self = this;
        self.setState({ 'isLoading': true })

        if (!this.state.mobile) {
            toast.error(strings["mobileNumPlaceholder"]);
            return false;
        }
        if (this.state.otp_code == '') {
            toast.error(strings["verificationCodePlaceholder"]);
            return false;
        }

        let dataJson = {
            mobile: self.state.mobile,
            otp_code: self.state.otp_code,
            lang: self.state.lang
        };
        axios({
            method: 'POST',
            url: api.ProfileEdit,
            data: dataJson,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json',
            }
        }).then(function (response) {
            self.setState({ 'isLoading': false })
            if (response.data.error == 202 || response.data.error == '202') {
                if (response.data.errors && response.data.errors.length != 0) {
                    self.setState({ errorMessage: response.data.errors });
                } else {
                    var err_result = response.data.message.split("\r\n");
                    err_result.forEach(data => {
                        if (data) {
                            toast.error(data);
                        }
                    });
                }
            } else {
                toast.success(response.data.message);
                self.setState({ isOTP_code: response.data.otp_code });
                self.setState({ isAuthenticated: true });
            }
        }).catch(function (error) {
            toast.error(strings["no_internet"]);
        });
    }

    render() {
        if (this.state.isAuthenticated) {
            return <Navigate to="/" />;
        }
        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                <SubHeader data={{ title: "Mobile Update" }} />

                <div className='mobileUpdateScreen'>
                    <main className="reset-container">
                        <form className="reset-mobile">
                            <div className="form-group">
                                <label htmlFor="mobileNumPlaceholder" id="mobileNumLabel">
                                    {strings["mobileNumLabel"]}<span>*</span>
                                </label>
                                <input
                                    onChange={(e) => this.setState({ mobile: e.target.value })}
                                    defaultValue={this.state.mobile}
                                    type="tel"
                                    id="mobileNumPlaceholder"
                                    placeholder={strings["mobileNumPlaceholder"]}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="verificationCodePlaceholder" id="verificationCodeLabel" >
                                    {strings["verificationCodeLabel"]}<span>*</span>
                                </label>
                                <div className="verification-group">
                                    <input
                                        onChange={(e) => this.setState({ otp_code: e.target.value })}
                                        defaultValue={this.state.otp_code}
                                        type="text"
                                        id="verificationCodePlaceholder"
                                        placeholder={strings["verificationCodePlaceholder"]}
                                        required
                                    />
                                    <Button onClick={() => this.RequestOTP()} type="button" id="otpButton" className="otp-button" loading={this.state.otpLoading}>{strings["otpButton"]}</Button>
                                </div>
                            </div>

                            <div className="button-wrap">
                                <Button onClick={() => this.onPressProfile()} type="button" id="submitButton" className="submit-button" loading={this.state.isLoading}>{strings["submitButton"]}</Button>
                            </div>
                        </form>
                    </main>
                </div>
            </>
        );
    }
}

export default MobileUpdateScreen;
